import { MdContrast } from 'react-icons/md';

import { AccessibilityOption } from './AccessibilityButton';
import useAccesibilityActions from './hooks/useAccesibilityActions';

const HightContrasteOption = () => {
  const { toggleHightContrast } = useAccesibilityActions();

  return (
    <AccessibilityOption
      name={'Alto contraste'}
      icon={<MdContrast className="h-[12px] w-[12px] fill-white" />}
      onClick={() => toggleHightContrast()}
    />
  );
};

export default HightContrasteOption;
